<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>TIPO DE DOCUMENTOS LEGALES</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>PAS_Doc_legales</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>
              <b-form-group align="left">
                <label for="nombreBusq">Palabra clave</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                    name="nombre"
                    placeholder="Nombre del documento"
                     v-model="filtro.palabraClave" @keydown.enter.native="obtenerTipoDocumentosLegal"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col></b-col>

            <b-col
              align="right"
              v-if="$localStorageService.can('PAS_02_Doc_legales_agregar')"
            >
              <b-button
                v-b-tooltip.hover
                title="Crear tipo documento"
                variant="outline-success"
                @click="agregar()"
                >Crear tipo documento
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
            <b-row>
        <b-col cols="12">
          <b-table
            id="Pendientes"
            thead-tr-class="columnas"
            :items="datosTabla"
            :fields="fields"
            :per-page="registrosPorPagina"
            :current-page="paginaActual"
            responsive="true"
            class="parrafos"
            fixed
          >
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                    v-if="$localStorageService.can('PAS_02_Doc_legales_edit')"
                    title="Modificar tipo de documento"
                    size="sm"
                    variant="outline-warning"
                    @click="modificar(row.item)"
                ><em class="fa fa-pencil"></em></b-button>
                <b-button v-if="!row.item.registroActivo && $localStorageService.can('PAS_02_Doc_legales_inac')"
                          title="Activar tipo de documento"
                          variant="outline-danger"
                          size="sm"
                           @click="activarDesactivarMotivo(row.item)"
                ><em class="fa fa-undo"></em></b-button>
                <b-button v-else-if="$localStorageService.can('PAS_02_Doc_legales_inac')"
                          title="Eliminar tipo de documento"
                          variant="outline-danger"
                          size="sm"
                           @click="activarDesactivarMotivo(row.item)"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
              </b-button-group>

            </template>
          </b-table>
       <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>
    </b-container>
       <b-modal
        v-model="show"
        :title="tituloModal"
        size="lg"
    >
     <b-container fluid>
          <b-row>
               <b-col>
                   <b-form>
                       <b-form-group align="left">
                <label for="tipoDocumententoLegal">Nombre Tipo Documento
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input id="tipoDocumententoLegal" name="tipoDocumententoLegal" placeholder="Nombre del tipo de documento"
                               v-model="$v.tipoDocumento.tipoDocumententoLegal.$model"
                                :state="validateState('tipoDocumententoLegal')"                            
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
                   </b-form>
               </b-col>
            <b-col>
              <label>Elige el modulo:</label>
              <v-select label="modulo"
                 :options="tipoModulos"
                  v-model="$v.tipoDocumento.tipoModulo.$model"
                  :state="validateState('tipoModulo')"
                  :class="selectClass('tipoModulo')"
                  style="width: 95%">
                <span slot="no-options">No hay datos</span>
              </v-select>
          </b-col>
          </b-row>
     </b-container>
         <div slot="modal-footer">
        <b-button variant="outline-primary" :disabled="loaderAcciones" @click="guardar()">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Header from "../../components/Header";
import {required} from "vuelidate/lib/validators";
export default {
  components: {
    Header,
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
    datosTabla: [],
      fields: [
        { key: "idTipoDocumentoLegal", label: "ID", sortable: true },
        { key: "tipoDocumententoLegal", label: "Nombre", sortable: true },
        "Acciones",
      ],
      registrosPorPagina: 10,
      paginaActual: 0,
      filtro: {
        id: null,
        palabraClave: null,
        registroActivo: null
      },
     tipoDocumento:{
        idTipoDocumentoLegal: null,
        tipoDocumententoLegal: null,
        tipoModulo: null,
        registroActivo: null
      },
     tituloModal: '',
     loaderAcciones: false,
     show: false,
     loader: false,
     tipoModulos:
        [{idModulo: 1, modulo: "DOCUMENTOS LEGALES"},
        {idModulo: 2, modulo: "EMISION/RENOVACION DE CUENTAS"}
        ]
    };
  },
  validations: {
    tipoDocumento: {
      tipoDocumententoLegal:{required},
      tipoModulo:{required}
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
this.obtenerTipoDocumentosLegal();
  },
  methods: {
    obtenerTipoDocumentosLegal() {
     this.loader = true;
      this.$http
        .post(this.$api + "portalautoservicio/catalogo/tipoDocumentosLegalFiltro", this.filtro)
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.datosTabla = respuesta.data.data;
          }
        })
        .finally(() => {
        this.loader = false;
        });  
    },
    activarDesactivarMotivo(item){
     const mensaje = item.registroActivo ? '¿Está seguro de desactivar el tipo de documento?' : '¿Está seguro de activar el tipo de documento?';
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const parametros = {
            idTipoDocumentoLegal: item.idTipoDocumentoLegal,
          }
          this.$http.post(this.$api + 'portalautoservicio/catalogo/activarDesactivarTipoDocumentoLegal', parametros).then(respuesta => {
                if (respuesta.data.data) {
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "El tipo de documento se actualizó correctamente",
                  });
                }
              }
          )
        }
      })
    },
  agregar() {
      this.tipoDocumento = {
          idTipoDocumentoLegal: null,
          tipoDocumententoLegal: null,
          tipoModulo: null,
          registroActivo: true
      };
      this.tituloModal = 'Agregar Tipo Documento';
      this.show = true;
    },
   validateState(name) {
      const {$dirty, $error} = this.$v.tipoDocumento[name];
      return $dirty ? !$error : null;
    },
  selectClass(attribute) {
      let state = this.validateState(attribute)
      if (state) {
        return 'border rounded-lg border-success'
      } else if (state === false) {
        return 'border rounded-lg border-danger'
      } else {
        return ''
      }
    },
  guardar(){
     this.$v.tipoDocumento.$touch();
      if (this.$v.tipoDocumento.$anyError) {
        return;
      }
      if (!this.$v.tipoDocumento.$invalid) {
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'portalautoservicio/catalogo/guardartipoDocumentosLegal', this.tipoDocumento).then(respuesta => {
              if (respuesta.data.data) {
                this.filtro = {
                   id: null,
                   palabraClave: null,
                  registroActivo: null
                };
                this.obtenerTipoDocumentosLegal();
                this.show = false;
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "El tipo de documento se guardó correctamente",
                });
              }
            }
        ).finally(() => {
              this.loaderAcciones = false;
            }
        )
      }
    },
      modificar(item) {
      this.tipoDocumento = JSON.parse(JSON.stringify(item));
      this.tituloModal = 'Modificar Tipo de Documento';
      this.show = true;
    },
     cerrarModal() {
      this.show = false;
    }
    }
};
</script>

<style>
</style>